import { format as formatDate } from 'date-fns'

export default {
  methods: {
    humanFriendlyDateTime(date) {
      if (!date) {
        return ''
      }
      return formatDate(date, 'MM/dd/yy h:mmaaa')
    },
    humanFriendlyDate(date) {
      if (!date) {
        return ''
      } else if (typeof date === 'string') {
        return date
      } else {
        return formatDate(date, 'MM/dd/yyyy')
      }
    }
  }
}
